const payEnum = [
  {
    img:'images/icon/money/Credit_Card_black.svg',
    act_img: 'images/icon/money/Credit_Card.svg',
    label: 'Credit Card',
    value: 1
  },
  {
    img:'images/icon/money/Crypto_black.svg',
    act_img:'images/icon/money/Crypto.svg',
    label: 'Crypto',
    value: 2
  },
  {
    img:'images/icon/money/Local_Payment_black.svg',
    act_img:'images/icon/money/Local_Payment.svg',
    label: 'Local Payment',
    value: 3
  },
  {
    img:'images/icon/money/Digital_Wallet_black.svg',
    act_img:'images/icon/money/Digital_Wallet.svg',
    label: 'Digital Wallet',
    value: 4
  },
  {
    img:'images/icon/money/Bank_Transfer_black.svg',
    act_img:'images/icon/money/Bank_Transfer.svg',
    label: 'Bank Transfer',
    value: 5
  }
]

export {
  payEnum
}